import { Component } from '@angular/core';

import { applyDeviceClassFlags } from './helpers/device-class-flags.helper';
import { NativeDeviceIdentifierService } from './walk-up-bays/services/native-device-identifier.service';
import { NetworkMonitorService } from './services/network-monitor.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(
    private readonly networkMonitorService: NetworkMonitorService,
    private readonly nativeDeviceIdentifierService: NativeDeviceIdentifierService
  ) {
    // Tag <html> with the device-class flags so plain CSS can tell an installed
    // package from a browser without injecting a service. Synchronous and done
    // here, before any routing: `ee-native-build` depends only on the platform
    // id, so it is correct from the first frame, whereas the kiosk ROUTE answer
    // (`KioskContextService.isKiosk`) does not exist until a `/kiosk` route
    // activates. Vocabulary and the presentation-only caveat live in
    // `helpers/device-class-flags.helper.ts`.
    applyDeviceClassFlags({
      isNative: this.nativeDeviceIdentifierService.isNativePlatform(),
      platform: this.nativeDeviceIdentifierService.getPlatform()
    });

    this.networkMonitorService.refreshStatus().catch(() => {});
  }
}
